import React from 'react';

/**
 * Component for tags
 * @param name the value that will be displayed in the center of the tag
 * @param index the index
 * @param handleClick function to handle what happens when tag is clicked
 * @param type the type of tag
 * @param showCloseIcon should the close icon be shown on the right side? true if yes, false if no
 */
const Tag = ({ name, index, handleClick, type, showCloseIcon }) => {
	return (
		<li
			className="tag-container-li"
			onClick={() => handleClick(index, type)}
			key={index + name}
		>
			<p className="body-font tag-text">{name}</p>
			{showCloseIcon ? (
				<i
					id="location-tag-delete-button"
					className="fas fa-times float-right"
				/>
			) : (
				''
			)}
		</li>
	);
};

export default Tag;
